import React from 'react';
import RichText from 'components/rich-text';
import PropTypes from 'prop-types';

const FooterColumn = ({ heading, textHtml }) => {
  return (
    <div className="footer-column">
      {heading && <h2 className="footer-column__heading">{heading}</h2>}
      {textHtml && <RichText text={textHtml} className="rich-text_in-footer" />}
    </div>
  );
};

FooterColumn.propTypes = {
  heading: PropTypes.string,
  textHtml: PropTypes.string,
};

export default FooterColumn;
